import React from 'react';
import { useDashboardAuth } from '@quality24/react-auth';
import { useAccountIdentity } from '@quality24/react-components';

import groups from '../../routes/groups';
import { AuthResponsePayload } from '../../@types/auth';
import menuContext, { MenuContext } from './menuContext';

export interface Props {
  children: React.ReactNode;
}

const MenuProvider: React.FunctionComponent<Props> = ({ children }) => {
  const { userData } = useDashboardAuth<AuthResponsePayload['userData']>();
  const { hasPermission } = useAccountIdentity(userData.sub);

  const menu = React.useMemo(
    () =>
      groups
        .map((g) => ({
          ...g,
          items:
            g.label === 'Gestão'
              ? [
                  ...g.items
                    .filter(
                      (i) => hasPermission(i.permission) && !i.routingOnly,
                    )
                    .map(({ permission, lazy, routingOnly, ...i }) => i),
                ]
              : g.items
                  .filter((i) => hasPermission(i.permission) && !i.routingOnly)
                  .map(({ permission, lazy, routingOnly, ...i }) => i),
        }))
        .filter((g) => g.items.length !== 0),
    [hasPermission],
  );

  const value: MenuContext = React.useMemo(() => ({ menu }), [menu]);

  return <menuContext.Provider value={value}>{children}</menuContext.Provider>;
};

export default MenuProvider;
